export default __webpack_public_path__ + "static/media/2b667d060944ab387d2db4da8bd6d3f4.8bed9b7f.svg";